module.exports = __webpack_public_path__ + "fonts/Fontfabric - Uni Sans Bold Italic.ec7a4ebe.ttf";